import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import type { ApplyCloseTemplateEntitySelectionRow } from "../applyCloseTemplateEntitySelection.types";
import { ApplyCloseEntityMemberCell } from "./ApplyCloseEntityMemberCell";

export const ApplyCloseEntityPreparerCell = memo(
    function ApplyCloseEntityPreparerCell({
        row,
    }: CellContext<
        ViewTableFeatures,
        ApplyCloseTemplateEntitySelectionRow,
        string
    >) {
        return (
            <ApplyCloseEntityMemberCell
                row={row}
                field="preparerId"
                addText="Assign preparer"
                emptyLabel="No preparer"
            />
        );
    },
);
